import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useActiveCompany } from "@/hooks/use-active-company";

export const Route = createFileRoute("/_authenticated/calculations")({
  head: () => ({
    meta: [
      { title: "Beregninger | VERQO" },
      { name: "description", content: "Fagberegninger for elektro og tømrer." },
    ],
  }),
  component: CalculationsLayout,
});

function CalculationsLayout() {
  const { activeModule } = useActiveCompany();
  const navigate = useNavigate();
  const allowed = activeModule?.hasCalculations === true;

  useEffect(() => {
    if (activeModule && !allowed) {
      navigate({ to: "/dashboard", replace: true });
    }
  }, [activeModule, allowed, navigate]);

  if (!activeModule || !allowed) return null;
  return <Outlet />;
}
